export default function(closeHandlerName, propertyHandleName) {
	return {
		mounted() {
			if (propertyHandleName === undefined || this[propertyHandleName]) {
				document.addEventListener('click', this.handleDocumentClicked);
			}
		},
		beforeDestroy() {
			if (propertyHandleName === undefined || this[propertyHandleName]) {
				document.removeEventListener(
					'click',
					this.handleDocumentClicked
				);
			}
		},
		methods: {
			handleDocumentClicked(event) {
				const { target } = event;
				const { $el } = this;
				if (!$el.contains(target)) {
					this[closeHandlerName]();
				}
			}
		}
	};
}
